// extracted by mini-css-extract-plugin
export default {"quantitySelect":"_7634d8a6"};